module.exports = __webpack_public_path__ + "static/assets/622321b437cc79dd9ed885540a94505a.svg";